import page from './page';
import education from './education';
import training from './training';
export default {
  page,
  education,
  training,
};
